/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Meta, Meta$inboundSchema } from "./meta.js";
import {
  V1AppsCreateAppResponseData,
  V1AppsCreateAppResponseData$inboundSchema,
} from "./v1appscreateappresponsedata.js";

export type V1AppsCreateAppResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  data: V1AppsCreateAppResponseData;
};

/** @internal */
export const V1AppsCreateAppResponseBody$inboundSchema: z.ZodType<
  V1AppsCreateAppResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: V1AppsCreateAppResponseData$inboundSchema,
});

export function v1AppsCreateAppResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1AppsCreateAppResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1AppsCreateAppResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1AppsCreateAppResponseBody' from JSON`,
  );
}
